import { z } from 'zod';
import { nullableUuidString, optionalUuidString } from '../zod-helpers/index.js';
import { bomWarehouseIdsSchema } from './bom-warehouse-ids-schema.js';
import { bomDescriptionSchema, bomNoteSchema, bomUrlSchema } from './create-form.js';
export const updateBomInputSchema = z.object({
    description: bomDescriptionSchema.optional(),
    // Unlike add-item-input.ts, must preserve `undefined` (omitted) distinct from `null` — resolveUpdateBom's `input.partId !== undefined` gates a permission check.
    partId: optionalUuidString('Invalid part selection.')
        .optional()
        .nullable()
        .transform((value) => (value == null ? value : value.trim() || null)),
    // setPartDefaultBom's reassignment token: omitted refuses to move the part off an active default; null means "shown as unclaimed"; a BOM id means "shown as that BOM's current holder".
    confirmedAgainstBomId: nullableUuidString('Invalid BOM confirmation.').optional(),
    note: bomNoteSchema,
    // configurable is intentionally absent — derived from Option Groups, not client-writable here.
    // NOT NULL column — no .nullable(), so an explicit null fails instead of no-op updating.
    pickFromLocation: z.boolean().optional(),
    url: bomUrlSchema,
    // .nullish() — GraphQL may send null; resolver rewrites only for a real array (incl. []).
    warehouseLocationGroupIds: bomWarehouseIdsSchema.nullish(),
});
//# sourceMappingURL=update-input.js.map